<template>
  <v-sheet class="rounded-xl pa-4 pb-2">
    <v-card class="rounded-xl" flat style="overflow-x: scroll; scrollbar-width: none;" ref="scrollContainer">
      <v-sheet style="height: 100%; display: inline-flex; " class="mx-n2">
        <v-card v-for="(item, key) in data" :key="key" width="300px" class="rounded-xxl mx-2 d-flex flex-column" elevation="0">
          <v-img cover :src="item.avatar ? (item.avatar.includes('pdf')? '/static/file_placeholder.jpg': item.avatar) : '/static/file_placeholder.jpg'" 
          class="rounded-xxl" width="100%" max-height="150px" style="cursor: pointer;" @click="viewModal = true, selected = item" >
          </v-img>
          
          <div class="d-block">
            <v-chip :color="`${item.contentCategoryCodeNavigationColor} lighten-4`" :text-color="item.contentCategoryCodeNavigationColor" class="my-2 font-weight-bold" small >{{ item.contentCategoryCodeNavigationTitle }}</v-chip>
          </div>
          <v-card-title class="text-subtitle-2 font-weight-bold py-0" style="text-transform: uppercase; word-break: normal; cursor: pointer;" @click="viewModal = true, selected = item">
            {{item.title}}
          </v-card-title>
          <v-card-actions class="pt-0">
            <!-- avatar -->
            <v-avatar size="32px">
              <v-img :src="item.createdByNavigationAvatar" sizes="32"></v-img>
            </v-avatar> 
            <v-card flat class="pa-0">
              <v-card-title class="text-subtitle-1 font-weight-bold px-2 py-2">
                <small>{{ item.createdByNavigationName }}</small>
              </v-card-title>
              <v-card-subtitle class="text--secondary px-2 py-2">
                <small>{{ $formatter.formatDate(item.createdAt, "DD/MM/YYYY HH:mm:ss") }}</small>
              </v-card-subtitle>
            </v-card>
          </v-card-actions>
        </v-card>

        <v-dialog v-model="viewModal" width="800px" class="rounded-xl">
          <v-card v-if="selected" class="rounded-xl">
            <v-card-title class="text-subtitle-1" style="word-break: normal;">
              {{ selected?.title }}
            </v-card-title>
            <v-img v-if="!selected.avatar?.includes('.pdf')" :src="selected.avatar"></v-img>
            <iframe v-else
              :src="selected.avatar"
              style="width:100%; height:500px; border:none;"
          ></iframe>
            <v-card-text >
              <span v-html="selected?.brief"></span>
            </v-card-text>
            <v-card-actions>

            </v-card-actions>
          </v-card>
        </v-dialog>
      
      </v-sheet>
    </v-card>
  </v-sheet>
</template>

<script>

export default {
  name: "media",
  props: ["data"],
  data() {
    return {
      // sliders: [],
      // news: []
      viewModal: false,
      selected: null
    }
  },
  methods: {
    scrollLeft() {
      console.log(this.$refs.scrollContainer)
      this.$refs.scrollContainer.$el.scrollBy({
        left: -150,
        behavior: "smooth"
      });
    },
    scrollRight() {
      this.$refs.scrollContainer.$el.scrollBy({
        left: 150,
        behavior: "smooth"
      });
    },
  },
  mounted() {
    // this.getContents()
  }
}
</script>